<template>
  <div :class="['preview-viewer video-viewer', this.item.extension_category]" ref="videoWrap">
      <div
        class="video-js vjs-big-play-centered"
        id="video-player-container"
      ></div>
  </div>
</template>
<script>
import '../../lib/VCloudPlayer.min.js'
// import config from '../../config'

const getType = (fileName) => {
  if (!fileName || fileName.indexOf('.') === -1) return ''
  const suffix = fileName.split('.').pop().toLowerCase()
  switch (suffix) {
    case 'mp4':
      return 'mp4'
    case 'flv':
      return 'flvjs'
    case 'm3u8':
      return 'hls'
    default:
      return 'other'
  }
}

export default {
  name: 'VideoViewer',
  props: {
    previewInfo: Object,
    item: Object
  },
  data () {
    return {
      player: null
    }
  },
  methods: {
    initPlayer () {
      this.player = new window.VCloudPlayer()
      // const loginUser = config.user_info || {}

      this.player.createPlayer({
        // uid: loginUser.id,
        // bid: 'fangcloud',
        pid: 'h5',
        isLive: false,
        src: this.previewInfo.download_url,
        autoplay: false,
        container: 'video-player-container',
        poster: this.previewInfo.poster,
        mediaData: {
          type: getType(this.previewInfo.download_url)
        },
        controls: true,
        showLoading: true,
        pip: false,
        currentPlaybackRate: 1,
        playbackRate: [0.5, 1, 1.5, 2]
      })

      this.player.on('error', (err) => {
        console.log(err)
        if (this.player) {
          this.player.destroy()
          this.player = null
        }
        this.$emit('video-error')
      })
    }
  },
  mounted () {
    this.initPlayer()
  },
  beforeDestroy () {
    if (this.player) {
      this.player.destroy()
      this.player = null
    }
  }
}
</script>
<style>
  .preview-viewer.video-viewer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
